module.exports = __webpack_public_path__ + "img/pm.5757afe5.png";